import { useAppStore } from '../stores/appStore'

export function getDefaultProduct(): string {
  const appStore = useAppStore()

  if (appStore.configuration?.components.productSelect) {
    if (
      appStore.selectedProduct &&
      appStore.configuration?.components.productSelect.availableProducts.includes(
        appStore.selectedProduct
      )
    ) {
      return appStore.selectedProduct
    }
    if (appStore.configuration?.components.productFromUrl?.enabled && appStore.productFromUrl) {
      return appStore.productFromUrl
    }
    if (appStore.configuration?.components.productSelect.defaultProduct) {
      return appStore.configuration!.components.productSelect.defaultProduct
    }
    return ''
  }
  return ''
}

export function getIsProductSelectValid() {
  const appStore = useAppStore()
  const productSelect = appStore.configuration?.components.productSelect

  if (!productSelect) {
    return false
  }

  if (!productSelect.visible) {
    return true
  }

  if (!productSelect.selectionRequired) {
    return true
  }

  if (appStore.configuration?.components.productFromUrl?.enabled && appStore.productFromUrl) {
    return productSelect.availableProducts.includes(appStore.productFromUrl)
  }

  const selectedProduct = appStore.selectedProduct
  return (
    typeof selectedProduct === 'string' &&
    selectedProduct.trim() !== '' &&
    productSelect.availableProducts.includes(selectedProduct)
  )
}

export function setProduct(value: string | null): void {
  const appStore = useAppStore()

  appStore.setSelectedProduct(
    value ?? appStore.configuration?.components.productSelect.defaultProduct ?? ''
  )
}
